
const ContactWidget = {
template: `
  <div class="contact-widget">
    <div class="contact-links" :class="{ active: isOpen }">
      <button @click="toggleWebsiteChat" :class="['contact-links__button-root launcher-container', { open: isAnyChatOpen }]">
          <span
            :class="['contact-open launcher-content-container', !isAnyChatOpen ? 'fade-enter-active' : 'fade-leave-active']"
            v-show="!isAnyChatOpen"
          >
          <span class="launcher-text">{{ contactWidgetText }}</span>
          <img :src="paigeImageUrl" alt="Contact image" class="paige-image" />
        </span>
        
        <span
          :class="['contact-close', isAnyChatOpen ? 'fade-enter-active' : 'fade-leave-active']"
          v-show="isAnyChatOpen"
        >
          &#215;
        </span>
      </button>

    <transition name="chat-fade">
    <div v-if="showChatPanel" class="contact-chat-panel">
      <!-- HEADER -->
      <div class="chat-header">
        <div class="chat-avatar-wrapper">
          <img :src="agentPhoto" :alt="agentName" class="chat-avatar" />
          <span class="chat-status-indicator"></span>
        </div>
        <div class="chat-header-text">
          <div class="chat-agent-name">{{ agentName }}</div>
          <div class="chat-agent-status">Online</div>
        </div>
      </div>

      <div class="chat-messages" ref="chatMessages">
        <div class="chat-timestamp">{{ currentTime }}</div>
      
        <div
          v-for="(msg, index) in chatMessages"
          :key="index"
          :class="['chat-message', msg.sender]"
        >
          <div v-if="msg.isTyping" class="typing-bubble">
            <span class="typing-dots">
              <span></span><span></span><span></span>
            </span>
          </div>
          <div v-else>
            {{ msg.text }}
          </div>
        </div>
      </div>

      <div class="chat-contact-icons">
        <div v-for="(item, index) in items" :key="index" class="contact-links__item">
          <button
            :style="{ background: item.color }"
            class="contact-links__button--small"
            @click="item.action"
            :data-tooltip="item.name"
          >
            <img :src="item.icon" :alt="item.name" />
          </button>
        </div>
      </div>
    </div>
    </transition>
    
  </div>

  </div>
`,
  data() {
    return {
      isOpen: false,
      gorgiasReady: false,
      isGorgiasOpen: false,
      showChatPanel: false,
      newMessage: '',
      chatDotsIconUrl: window.chatDotsIconUrl,
      paigeImageUrl: window.paigeImageUrl,
      items: [], // items will be populated in created()
      chatMessages: [],
      agentName: window.agentName || 'John Doe',
      agentPhoto: window.agentPhoto || 'https://via.placeholder.com/40',
      defaultChatMessage: window.defaultChatMessage,
      currentTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };
  },
  
  created() {
    const chatItems = [];
  
    if (window.enableNaturopathChat) {
      chatItems.push({
        name: "Chat to a Naturopath",
        color: window.naturopathChatColor,
        icon: window.naturopathChatIconUrl,
        action: () => this.toggleGorgiasChat('naturopath')
      });
    }
    if (window.enableWhatsApp) {
      chatItems.push({
        name: "WhatsApp",
        color: window.whatsappColor,
        icon: window.whatsappIconUrl,
        action: this.openWhatsApp
      });
    }
    if (window.enableMessenger) {
      chatItems.push({
        name: "Facebook Messenger",
        color: window.messengerColor,
        icon: window.messengerIconUrl,
        action: this.openMessenger
      });
    }
    if (window.enableInstagram) {
      chatItems.push({
        name: "Instagram Chat",
        color: window.instagramColor,
        icon: window.instagramIconUrl,
        action: this.openInstagram
      });
    }
    if (window.enableTikTok) {
      chatItems.push({
        name: "TikTok Messaging",
        color: window.tiktokColor,
        icon: window.tiktokIconUrl,
        action: this.openTikTok
      });
    }
    if (window.enableSMS) {
      chatItems.push({
        name: "SMS",
        color: window.smsColor,
        icon: window.smsIconUrl,
        action: this.openSMS
      });
    }
    if (window.enableEmail) {
      chatItems.push({
        name: "Email",
        color: window.emailColor,
        icon: window.emailIconUrl,
        action: this.openEmail
      });
    }
    if (window.enableLiveChat) {
      chatItems.push({
        name: "Website Live Chat",
        color: window.liveChatColor,
        icon: window.chatIconUrl,
        action: () => this.toggleGorgiasChat()
      });
    }
  
    this.items = chatItems;
  },
  computed: {
    isAnyChatOpen() {
      return this.showChatPanel || this.isGorgiasOpen;
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    
      if (!this.isOpen) {
        this.showChatPanel = false;
      }
    
      if (!this.isOpen && window.GorgiasChat && GorgiasChat.isOpen()) {
        GorgiasChat.close();
      }
    },
    toggleGorgiasChat(intent = null) {
      if (!window.GorgiasChat) return;
    
      const isOpen = GorgiasChat.isOpen();
    
      if (isOpen) {
        GorgiasChat.close();
        this.isGorgiasOpen = false;
      } else {
        if (intent === 'naturopath') {
          GorgiasChat.open({ defaultIntent: 'conversation' });
        } else {
          GorgiasChat.open();
        }
        this.isGorgiasOpen = true;
        this.showChatPanel = false;
      }
    }, 
    openWhatsApp() {
      const phoneNumber = window.whatsappPhoneNumber;
      const url = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text&type=phone_number&app_absent=0`;
      window.open(url, '_blank');
    },
    openMessenger() {
      const url = messengerUrl;
      window.open(url, '_blank');
    },
    openInstagram() {
      const url = window.instagramUrl;
      window.open(url, '_blank');
    },
    openSMS() {
      const phoneNumber = window.smsPhoneNumber;
      const url = `sms:${phoneNumber}?body=`;
      window.open(url, '_blank');
    },
    openTikTok() {
      const url = window.tiktokUrl;
      window.open(url, '_blank');
    },
    openEmail() {
      const emailAddress = window.emailAddress;
      const url = `mailto:${emailAddress}`;
      window.open(url, '_blank');
    },
    toggleWebsiteChat() {
      if (window.GorgiasChat && GorgiasChat.isOpen()) {
        GorgiasChat.close();
        this.isGorgiasOpen = false;
        return;
      }
    
      this.showChatPanel = !this.showChatPanel;
    
      if (this.showChatPanel && this.chatMessages.length === 0) {
        this.chatMessages.push({
          text: '...',
          sender: 'agent-typing',
          isTyping: true
        });
    
        setTimeout(() => {
          this.chatMessages = this.chatMessages.filter(msg => !msg.isTyping);
    
          this.chatMessages.push({
            text: this.defaultChatMessage,
            sender: 'agent'
          });
        }, 1400);
      }
    },
    sendChatMessage() {
      if (this.newMessage.trim() !== '') {
        const message = this.newMessage;
        this.chatMessages.push(message);
        this.newMessage = '';
  
        setTimeout(() => {
          this.chatMessages.push("Thanks for reaching out! We'll be with you shortly.");
        }, 800);
      }
    },     
    mounted() {
      setInterval(() => {
        this.currentTime = new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        });
      }, 60000);
    
      const waitForGorgias = setInterval(() => {
        if (window.GorgiasChat && typeof GorgiasChat.isOpen === 'function') {
          this.isGorgiasOpen = GorgiasChat.isOpen();
    
          GorgiasChat.on('open', () => {
            this.isGorgiasOpen = true;
          });
    
          GorgiasChat.on('close', () => {
            this.isGorgiasOpen = false;
          });
    
          clearInterval(waitForGorgias);
        }
      }, 50);
    }
  }
};

new Vue({
  el: '#contact-widget',
  components: {
    'contact-widget': ContactWidget,
  },
});
